import React from "react";

const Tiktok = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 9.18403V14.625C15 17.3174 12.8174 19.5 10.125 19.5C7.43261 19.5 5.25 17.3174 5.25 14.625C5.25 11.9326 7.43261 9.75 10.125 9.75C10.5122 9.75 10.8889 9.79514 11.25 9.88045V12.2526C10.9091 12.0906 10.5276 12 10.125 12C8.67525 12 7.5 13.1753 7.5 14.625C7.5 16.0747 8.67525 17.25 10.125 17.25C11.5748 17.25 12.75 16.0747 12.75 14.625V4.5H15C15 6.57106 16.679 8.25 18.75 8.25V10.5C17.3311 10.5 16.0272 10.0075 15 9.18403Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

export default Tiktok;
